<nz-layout class="app-details-container">
  <nz-sider [nzWidth]="270" class="sidebar" style="position: relative;">
    <div class="logo">
      <img src="assets/images/afsa-logo.svg" alt="afsa-logo">
      <span>Digital Resident</span>
    </div>
    <ul nz-menu [nzMode]="'vertical'" class="nz-menu">
<!--      <li nz-menu-item routerLink="/link1" routerLinkActive="active">-->
<!--        <i nz-icon nzType="ant-design"></i>-->
<!--        <span>Link 1</span>-->
<!--      </li>-->
    <li nz-menu-item (click)="goToApplications()" [class.active]="isActive('/applications')">
      <i nz-icon nzType="bars"></i>
      <span>Applications</span>
    </li>

    <li nz-menu-item *ngIf="showEntity" (click)="goToEntities()" [class.active]="isActive('/entities')">
      <i nz-icon nzType="ant-design"></i>
      <span>Entities</span>
    </li>

    <li nz-menu-item *ngIf="showPayments" (click)="goToPayments()" [class.active]="isActive('/payments')">
      <i nz-icon nzType="credit-card"></i>
      <span>Payments</span>
    </li>

    <li nz-menu-item *ngIf="showPrMigration" (click)="goToPrMigration()" [class.active]="isActive('/pr-migration')">
      <i nz-icon nzType="sync"></i>
      <span>PR migration</span>
    </li>

    <li nz-menu-item *ngIf="showAmlReporting" (click)="goToAmlReporting()" [class.active]="isActive('/aml-reporting')">
      <i nz-icon nzType="file-protect"></i>
      <span>AML Reporting</span>
    </li>

<!--      <li nz-menu-item routerLink="/link3" routerLinkActive="active">-->
<!--        <i nz-icon nzType="ant-design"></i>-->
<!--        <span>Link 3</span>-->
<!--      </li>-->
<!--      <li nz-menu-item routerLink="/link4" routerLinkActive="active">-->
<!--        <i nz-icon nzType="ant-design"></i>-->
<!--        <span>Link 4</span>-->
<!--      </li>-->
<!--      <li nz-menu-item routerLink="/link5" routerLinkActive="active">-->
<!--        <i nz-icon nzType="ant-design"></i>-->
<!--        <span>Link 5</span>-->
<!--      </li>-->
    </ul>
    <button
      nz-button
      nzShape="circle"
      class="sidebar-toggle"
      *ngIf="isCollapsed"
      (click)="isCollapsed = false"
    >
      <i nz-icon nzType="menu"></i>
    </button>
    <div class="collapse-button">
      <button
        nz-button
        nzShape="circle"
        nzType="text"
      >
        <i nz-icon nzType="menu-fold" style="color: rgba(0, 37, 84, 0.88)"></i>
      </button>
    </div>
  </nz-sider>

  <nz-layout>
    <nz-content>
      <app-header (toggleNotificationBar)="toggleNotificationBar()" (toggleCommunicationBar)="toggleCommunication()"></app-header>
      <div class="main-content">
        <router-outlet *ngIf="isShowContent"></router-outlet>
        <app-notification-view *ngIf="isShowNotificationView"></app-notification-view>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>



<app-notifications
  *ngIf="isShowNotifications"
  (hide)="toggleNotificationBar()"
>
</app-notifications>


<app-communication-modal
  *ngIf="isCommunicationModalVisible"
  [onCloseCommunicationModal]="handleCloseCommunicationModal"
/>
